/**
 * What the Copy action of a Settings › Accounts row reads beyond its row (ACT2-1124).
 *
 * A context rather than closures in the column definitions: `Table` rebuilds its column defs whenever the `columns`
 * array changes identity, and that remounts every cell and closes an open row menu. The copy state changes while a
 * copy runs, so the columns stay fixed and the Copy action reads the live state from here.
 */
import { createContext, useContext } from 'react';

import type { AccountCopyPick } from './useAccountCopyPick';

export interface AccountCopyContextValue {
  pick: AccountCopyPick;
  /** Why the person cannot copy an account (the grant set they lack), or null. */
  blockedReason: string | null;
}

export const AccountCopyContext = createContext<AccountCopyContextValue | null>(null);

export function useAccountCopyContext(): AccountCopyContextValue {
  const value = useContext(AccountCopyContext);
  if (value === null) throw new Error('The Copy action must render inside AccountCopyContext');
  return value;
}
